import { Directive, ElementRef, Input, OnChanges, OnInit } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[appBackgroundImage]',
})
export class BackgroundImageDirective implements OnInit, OnChanges {
  /**
   * @param appBackgroundImage URL of image
   */
  @Input() appBackgroundImage: string | null = '';

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.setImage();
  }

  ngOnChanges() {
    this.setImage();
  }

  private setImage() {
    if (!this.appBackgroundImage) {
      return;
    }
    this.el.nativeElement.style.backgroundImage = `url(${this.appBackgroundImage})`;
    this.el.nativeElement.style.backgroundSize = `cover`;
    this.el.nativeElement.style.backgroundPosition = `center`;
    this.el.nativeElement.style.backgroundRepeat = `no-repeat`;
    this.el.nativeElement.style.backgroundOrigin = `border-box`;
  }
}
